import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Injectable()
export class MatPaginatorIntlCustom extends MatPaginatorIntl implements OnDestroy {
	unsubscribe: Subject<void> = new Subject<void>();
	OF_LABEL = 'of';

	constructor(private translate: TranslateService) {
		super();

		this.translate.onLangChange.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
			this.getAndInitTranslations();
		});

		this.getAndInitTranslations();
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	getAndInitTranslations() {
		this.translate
			.get(['PAGINATOR.ITEMS_PER_PAGE', 'PAGINATOR.NEXT_PAGE', 'PAGINATOR.PREVIOUS_PAGE', 'PAGINOTOR.FIRST_PAGE', 'PAGINATOR.LAST_PAGE', 'PAGINATOR.OF_LABEL'])
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((translation) => {
				this.itemsPerPageLabel = translation['PAGINATOR.ITEMS_PER_PAGE'];
				this.nextPageLabel = translation['PAGINATOR.NEXT_PAGE'];
				this.previousPageLabel = translation['PAGINATOR.PREVIOUS_PAGE'];
				this.firstPageLabel = translation['PAGINATOR.FIRST_PAGE'];
				this.lastPageLabel = translation['PAGINATOR.FIRST_PAGE'];
				this.OF_LABEL = translation['PAGINATOR.OF_LABEL'];
				this.changes.next();
			});
	}

	override getRangeLabel = function (page, pageSize, length) {
		if (length === 0 || pageSize === 0) {
			return `0 ${this.OF_LABEL} ${length}`;
		}
		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		// If the start index exceeds the list length, do not try and fix the end index to the end.
		const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
		return `${startIndex + 1} - ${endIndex} ${this.OF_LABEL} ${length}`;
	};
}
